import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  const roles = ['Fuerza máxima', 'Resistencia cardiovascular', 'Composición corporal', 'Movilidad y estabilidad', 'Recuperación real', 'Mentalidad y adherencia'];
  return <section className="py-20 sm:py-32 px-4 bg-carbon-950 relative border-t border-carbon-800" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        <FadeIn data-id="element-171">
          <div className="flex items-center gap-4 mb-12" data-id="element-172">
            <span className="font-display text-4xl text-carbon-800" data-id="element-173">01</span>
            <div className="h-px bg-carbon-800 flex-grow" data-id="element-174" />
            <span className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-175">
              El Problema
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-176">
          <div className="prose prose-invert prose-lg max-w-none font-sans" data-id="element-177">
            <p className="text-carbon-300 leading-relaxed mb-6" data-id="element-178">
              Hay algo que casi nadie que entrena dice en voz alta pero que la
              mayoría siente.
            </p>
            <div className="font-mono text-sm text-carbon-400 uppercase tracking-widest space-y-2 mb-8 border-l border-electric/30 pl-4" data-id="element-179">
              <p data-id="element-180">No es que no tienen ganas.</p>
              <p data-id="element-181">No es que no se esfuerzan.</p>
              <p className="text-electric" data-id="element-182">Es algo más frustrante que eso.</p>
            </div>

            <div className="bg-carbon-900 border border-carbon-800 p-8 sm:p-12 mb-12 relative rounded-3xl overflow-hidden" data-id="element-183">
              <div className="absolute top-0 left-0 w-1 h-full bg-electric" data-id="element-184" />
              <p className="text-carbon-100 font-medium leading-relaxed mb-6 text-lg" data-id="element-185">
                Es la sensación de que después de meses entrenando, de videos
                vistos, de rutinas seguidas y de esfuerzo real, todavía llegás
                al lunes con la misma pregunta:
              </p>
              <p className="text-3xl sm:text-5xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-186">
                ¿Por qué mi cuerpo no avanza como debería?
              </p>
            </div>

            <p className="text-carbon-300 leading-relaxed mb-12 text-lg" data-id="element-187">
              Y ahí empieza el ciclo de siempre. Buscás una rutina nueva. Seguís
              a otro influencer. Probás con más cardio. Probás con menos cardio.
              Subís el volumen. Lo bajás. Comprás un plan. Lo seguís tres
              semanas y lo abandonás.{' '}
              <strong className="text-white font-semibold" data-id="element-188">
                Y el cuerpo sigue igual.
              </strong>
            </p>

            <div className="mb-16" data-id="element-189">
              <h2 className="text-4xl sm:text-5xl font-display text-white mb-4 uppercase tracking-wide" data-id="element-190">
                El problema no es tu esfuerzo.
                <br data-id="element-191" />
                <span className="text-electric" data-id="element-192">
                  Es que nadie te dio el sistema.
                </span>
              </h2>
              <p className="text-carbon-400 font-mono text-sm uppercase tracking-widest mb-8" data-id="element-193">
                Entrenás para mejorar pero sin un plan que contemple:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-194">
                {roles.map((role, i) => <div key={i} className="bg-carbon-950 border border-carbon-800 rounded-2xl p-6 flex items-center justify-center text-center group hover:bg-carbon-900 transition-colors" data-id="element-195">
                    <span className="font-sans font-medium text-carbon-100 group-hover:text-electric transition-colors" data-id="element-196">
                      {role}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="border-t border-carbon-800 pt-8" data-id="element-197">
              <p className="text-carbon-300 leading-relaxed mb-6 text-lg" data-id="element-198">
                Eso es exactamente lo que el cuerpo de un atleta completo
                necesita.
              </p>
              <p className="text-carbon-300 leading-relaxed mb-6 text-lg" data-id="element-199">
                Y sin un sistema que integre todo eso, el resultado es siempre
                el mismo:{' '}
                <strong className="text-white font-semibold bg-electric/10 px-1" data-id="element-200">
                  progresión parcial, estancamiento frustrante y la sensación
                  permanente de que algo siempre falta.
                </strong>
              </p>
              <p className="text-carbon-300 leading-relaxed text-lg" data-id="element-201">
                No es falta de dedicación. Es que estás entrenando capacidades
                aisladas sin la arquitectura que las conecta.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}